import { useState, useEffect } from 'react';
import '../../TimeKeeping.css';
import '../../../../App.css';
import 'react-calendar/dist/Calendar.css'; // Import default calendar stylesheet
import { CreateButton, CreateSearchBarWithPlaceHolder } from '../../../CommonObjects';
import { SetAuditTrail, SetAuditTrailBulk } from '../../../Reports/AuditTrailReportEmployeeSetup';
import axios from '../../../../api/apiClient';
import { token, domain } from '../../../Security';
import 'react-tabs/style/react-tabs.css';
import loadingSpinner from '../../../../assets/loading.gif';
import { FEATURES } from '../../../../config/features';

import { DynamicFilterBar } from "../../../../v2/components/filters/DynamicFilterBar";
import { useFilterManager } from "../../../../v2/hooks/useFilterManager";

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
// icons
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SearchIcon from '@mui/icons-material/Search';
import ChecklistIcon from '@mui/icons-material/Checklist';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {
  Button,
  ClassificationSelectWithAll,
  DepartmentIdSelectWithAll,
  EmployeeTypeIdSelectWithAll,
  GeneralMessage,
  useGeneralMessage,
  VesselIdSelectWithAll
} from '../../../../common/APICommon';
import { CreateTable } from '../TimeEntriesTables/CreateTable';
import { AddForm } from '../TimeEntriesFormFld/AddForm';
import { EditForm } from '../TimeEntriesFormFld/EditForm';
import { DeleteForm } from '../TimeEntriesFormFld/DeleteForm';
import { ApproveForm } from '../TimeEntriesFormFld/ApproveForm';
import { EmployeeSelectForm } from '../TimeEntriesFormFld/EmployeeSelectForm';
// import { AddEmployeeGroup2LogsForm } from '../TimeEntriesFormFld/AddEmployeeGroup2LogsForm';
import { ExtractForm } from '../TimeEntriesFormFld/ExtractForm';
import { GenerateMessage } from '../components/GenerateMessage';
import { PayrollPeriodSelect } from '../../../../common/selectComponents/PayrollPeriodSelect';
// import { AddEmployeeTypeLogsForm } from '../TimeEntriesFormFld/AddEmployeeTypeLogsForm';
import { useGenerateFixedLogs } from '../../../../v2/hooks/useGenerateFixedLogs';
import { LoadingSpinner } from '../../../../common/Loading';
import { ConfirmationModal } from '../../../../common/Modal';
import GenerateEmployeeFixedLogs from '../TimeEntriesFormFld/GenerateEmployeeFixedLogs';

export function UploadTimeEntries({
  dateTimeRecordData,
  setDateTimeRecordData,
  setFetchUploads,
  employees,
  isRevert,
  isProcess,
  isPost,
  isDelete,
  isUpload,
  setIsRevert,
  setIsProcess,
  setIsPost,
  setIsDelete,
  setIsUpload,
  selectedDTR,
  setSelectedDTR,
  activeRowIds,
  setActiveRowIds,
  openUploadTamperedFormHandleClick,
  isSelectLogs,
  setIsSelectLogs,
  userAccess,
  user,
  filterData,
  fetchData,
  sectionFilter,
  setSectionFilter,
  locationFilter,
  setLocationFilter,
  employeeTypeFilter,
  setEmployeeTypeFilter,
  vesselFilter,
  setVesselFilter,
  departmentFilter,
  setDepartmentFilter,
  loading,
  filterClassificationId,
  setFilterClassificationId,
  showTampered,
  setShowTampered,

  payrollPeriodUploadedTimeEntries,
  setPayrollPeriodUploadedTimeEntries,
  generateUploadedTimeEntries,
  setApiFilterPayload,
  setAdditionalApiFilterPayload,
}) {
  var uploadTimeEntriesHeader = [
    "Id",
    "Employee Id",
    "Employee",
    "Classification",
    "Date",
    "Time In",
    "Device",
    "Time Out",
    "Device",
    ...(FEATURES.TIMEKEEPING_TBL_BREAKOUT ? ["Break Out"] : []),
    ...(FEATURES.TIMEKEEPING_TBL_BREAKOUT ? ["Device"] : []),
    ...(FEATURES.TIMEKEEPING_TBL_BREAKIN ? ["Break In"] : []),
    ...(FEATURES.TIMEKEEPING_TBL_BREAKIN ? ["Device"] : []),
    "Shift Name",
    "Reason for Tampering",
    "Approved?",
    "",
  ]
  var uploadTimeEntriesaccessor = [
    "id",
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "classificationDescription",
    "date",
    "timeIn",
    "deviceNameTimeIn",
    "timeOut",
    "deviceNameTimeOut",
    // "breakIn",
    // "deviceNameBreakIn",
    // "breakOut",
    // "deviceNameBreakOut",
    ...(FEATURES.TIMEKEEPING_TBL_BREAKOUT ? ["breakOut"] : []),
    ...(FEATURES.TIMEKEEPING_TBL_BREAKOUT ? ["deviceNameBreakOut"] : []),
    ...(FEATURES.TIMEKEEPING_TBL_BREAKIN ? ["breakIn"] : []),
    ...(FEATURES.TIMEKEEPING_TBL_BREAKIN ? ["deviceNameBreakIn"] : []),
    "employeePersonalInformationEmployeeInformationShiftScheduleShiftName",
    "reasonForTampering",
    "isApproved",
    "manage"
  ]

  const [approveMessage, setApproveMessage] = useState(false);

  // -- Generate Logs --
  const { generateLogs, loading: isGenerating } = useGenerateFixedLogs();

  // State for Fixed Logs Configuration Confirmation
  const [showConfirmGen, setShowConfirmGen] = useState(false);
  const [showGenerateEmployeeFixedLogs, setShowGenerateEmployeeFixedLogs] = useState(false);

  const { showMessage, message: employeeLogMessage, isSuccess: employeeLogIsSuccess, showGeneralMessage } = useGeneralMessage();
  // -- END Generate Logs --

  // Add
  const [showAddForm, setShowAddForm] = useState(false);
  const [showEmployeeForm, setShowEmployeeForm] = useState(false);
  const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
  const [employeePersonalInformationEmployeeId, setEmployeePersonalInformationEmployeeId] = useState("");
  const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
  const [date, setDate] = useState("");
  const [timeIn, setTimeIn] = useState("");
  const [deviceNameTimeIn, setDeviceNameTimeIn] = useState("");
  const [timeOut, setTimeOut] = useState("");
  const [deviceNameTimeOut, setDeviceNameTimeOut] = useState("");
  const [reasonForTampering, setReasonForTampering] = useState("");
  //Old
  const [oldTimeIn, setOldTimeIn] = useState("");
  const [oldDeviceNameTimeIn, setOldDeviceNameTimeIn] = useState("");
  const [oldTimeOut, setOldTimeOut] = useState("");
  const [oldDeviceNameTimeOut, setOldDeviceNameTimeOut] = useState("");
  const [oldReasonForTampering, setOldReasonForTampering] = useState("");
  //Update
  const [showEditForm, setShowEditForm] = useState(false);
  const [dataToEdit, setDataToEdit] = useState([]);
  // Delete
  const [showDeleteForm, setShowDeleteForm] = useState(false);
  const [dataToDelete, setDataToDelete] = useState([]);
  //Approve
  const [showApproveForm, setShowApproveForm] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);

  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [loadingRequest, setLoadingRequest] = useState(false);

  const {
    activeFilterState,
    onFilterChange,
    apiFilterPayload,
    additionalApiFilterPayload,
    applyFilters,
    resetFilters,
    // getFiltersAsDetails
  } = useFilterManager(FEATURES.TIME_KEEPING_FILTER);

  const handleClickShowTampered = () => {
    if (dateTimeRecordData.length <= 0) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("No Time Entries yet.");
      return;
    }

    setShowTampered(!showTampered);
  }

  const apiUrl = domain + "/api/EmployeeTimeRecord";

  const [currentPage, setCurrentPage] = useState(1);
  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeePersonalInformationEmployeeId.toString().startsWith(lowercaseValue)
        );
        break;
      default:
        res = filterData.filter((f) =>
          f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
        );

        break;
    }

    res = filterData.filter((f) =>
      f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue) ||
      f.employeePersonalInformationEmployeeId.toString().startsWith(lowercaseValue)
    );

    setDateTimeRecordData(res);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const data = {
      employeePersonalInformationId: employeePersonalInformationId,
      timeIn: timeIn,
      deviceNameTimeIn: deviceNameTimeIn,
      timeOut: timeOut,
      deviceNameTimeOut: deviceNameTimeOut,
      date: timeIn.split('T')[0],
      createdById: user.id,
      createdDate: new Date(),
    };

    try {
      setShowAddForm(false); // Hide the add form
      setLoadingRequest(true);
      await axios.post(apiUrl, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      await SetAuditTrail({
        setupArea: "Time Entries",
        actionTaken: "inser",
        field: "Add",
        newValue: `${employeePersonalInformationFullName}`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });

      await fetchData(); // Assuming fetchData() fetches the updated data for the table

      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset form fields
      setEmployeePersonalInformationId("");
      setEmployeePersonalInformationFullName("");
      setTimeIn("");
      setDeviceNameTimeIn("");
      setTimeOut("");
      setDeviceNameTimeOut("");
    } catch (error) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowAddForm(false);
  };
  const handleUpdate = async (event) => {
    event.preventDefault();

    const data = {
      employeePersonalInformationId: employeePersonalInformationId,
      employeePersonalInformationEmployeeId: employeePersonalInformationEmployeeId,
      date: date,
      timeIn: timeIn,
      deviceNameTimeIn: deviceNameTimeIn,
      timeOut: timeOut,
      deviceNameTimeOut: deviceNameTimeOut,
      reasonForTampering: reasonForTampering,
      createdById: dataToEdit.createdById,
      createdDate: dataToEdit.createdDate,
      updatedById: user.id,
      updatedDate: new Date()
    };

    try {
      setLoadingRequest(true);
      await axios.put(apiUrl + `/${dataToEdit.id}`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      let auditInfo = [];

      if (data.timeIn !== oldTimeIn) {
        auditInfo.push({
          setupArea: "Time Entries",
          actionTaken: "update",
          field: "Time In",
          newValue: `${data.timeIn}`,
          oldValue: `${oldTimeIn}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.deviceNameTimeIn !== oldDeviceNameTimeIn) {
        auditInfo.push({
          setupArea: "Time Entries",
          actionTaken: "update",
          field: "Device Time In",
          newValue: `${data.deviceNameTimeIn}`,
          oldValue: `${oldDeviceNameTimeIn}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.timeOut !== oldTimeOut) {
        auditInfo.push({
          setupArea: "Time Entries",
          actionTaken: "update",
          field: "Time Out",
          newValue: `${data.timeOut}`,
          oldValue: `${oldTimeOut}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.deviceNameTimeOut !== oldDeviceNameTimeOut) {
        auditInfo.push({
          setupArea: "Time Entries",
          actionTaken: "update",
          field: "Device Time Out",
          newValue: `${data.deviceNameTimeOut}`,
          oldValue: `${oldDeviceNameTimeOut}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.reasonForTampering !== oldReasonForTampering) {
        auditInfo.push({
          setupArea: "Time Entries",
          actionTaken: "update",
          field: "Reason for Tampering",
          newValue: `${data.reasonForTampering}`,
          oldValue: `${oldReasonForTampering}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      setShowEditForm(false); // Hide the add form
      await SetAuditTrailBulk({ data: auditInfo });
      await fetchData(); // Assuming fetchData() fetches the updated data for the table

      console.log('Data added successfully');
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset form fields
    } catch (error) {
      console.error('There was a problem adding data:', error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowEditForm(false);
  };
  const handleDelete = async () => {
    try {
      setLoadingRequest(true);
      await axios.delete(apiUrl + `/${dataToDelete.id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      setShowDeleteForm(false);
      await SetAuditTrail({
        setupArea: "Time Entries",
        actionTaken: "delete",
        field: "Delete Time Entry",
        newValue: `-`,
        oldValue: `${dataToDelete.employeePersonalInformationFullName}`,
        dateSaved: new Date(),
        savedById: user.id
      });
      await fetchData(); // Assuming fetchData() fetches the updated data for the table

      console.log('Deleted successfully');
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset state
      setDataToDelete("");
    } catch (error) {
      console.error('There was a problem deleting employee:', error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowDeleteForm(false);
  };
  const approveHandleClick = async () => {
    if (selectedDTR.length <= 0) {
      setApproveMessage(true);
      setRequestMessage("No selected record");
      setIsSuccess(false);
      closeApproveHandleClick();
      return;
    }

    let finalData = []
    selectedDTR.forEach(data => {
      const dataToUpdate = {
        id: data.id,
        employeePersonalInformationId: data.employeePersonalInformationId,
        employeePersonalInformationEmployeeId: data.employeePersonalInformationEmployeeId,
        date: data.date,
        timeIn: data.timeIn,
        deviceCodeTimeIn: data.deviceCodeTimeIn,
        deviceNameTimeIn: data.deviceNameTimeIn,
        timeOut: data.timeOut,
        deviceCodeTimeOut: data.deviceCodeTimeOut,
        deviceNameTimeOut: data.deviceNameTimeOut,
        reasonForTampering: data.reasonForTampering,
        isApproved: true,
        approvedById: user.id,
        approvedDate: new Date(),
        createdById: data.createdById,
        createdDate: data.createdDate,
        updatedById: data.updatedById,
        updatedDate: data.updatedDate
      };

      finalData.push(dataToUpdate)
    })

    setLoadingRequest(true);
    setShowApproveForm(false);

    try {
      await axios.put(apiUrl + `/approval-bulk`, finalData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      console.log('Updated successfully');

      await SetAuditTrail({
        setupArea: "Time Entries",
        actionTaken: "update",
        field: "Approve",
        newValue: "Approved",
        oldValue: "Pending",
        dateSaved: new Date(),
        savedById: user.id
      });

      // Reload table data and reset state
      await fetchData();

      setShowRequestMessage(true);
      setIsSuccess(true);
    } catch (error) {
      console.error('There was a problem updating record:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
      setShowRequestMessage(true);
      setIsSuccess(false);
    }

    setLoadingRequest(false);
    setSelectedDTR([]);
    setActiveRowIds([]);
  };

  useEffect(() => {
    fetchData();
    // setFetchUploads(() => fetchData());
  }, [fetchData,
    isRevert,
    isProcess,
    isPost,
    isDelete,
    isUpload,
    isSelectLogs
  ]);

  useEffect(() => {
    if (showEditForm) {
      setEmployeePersonalInformationEmployeeId(dataToEdit.employeePersonalInformationEmployeeId)
      setEmployeePersonalInformationId(dataToEdit.employeePersonalInformationId)
      setEmployeePersonalInformationFullName(dataToEdit.employeePersonalInformationFullName)
      setTimeIn(dataToEdit.timeIn)
      setDate(dataToEdit.date)
      setDeviceNameTimeIn(dataToEdit.deviceNameTimeIn)
      setTimeOut(dataToEdit.timeOut)
      setDeviceNameTimeOut(dataToEdit.deviceNameTimeOut)
      setReasonForTampering(dataToEdit.reasonForTampering)
      setOldTimeIn(dataToEdit.timeIn)
      setOldDeviceNameTimeIn(dataToEdit.deviceNameTimeIn)
      setOldTimeOut(dataToEdit.timeOut)
      setOldDeviceNameTimeOut(dataToEdit.deviceNameTimeOut)
      setOldReasonForTampering(dataToEdit.reasonForTampering)
    }
  }, [showEditForm,
    dataToEdit,
  ]);

  const addHandleClick = () => {
    setShowAddForm(true);
  };
  const editHandleClick = (data) => {
    setDataToEdit(data);
    setShowEditForm(true);
  };
  const deleteHandleClick = (data) => {
    setShowDeleteForm(true);
    setDataToDelete(data);
  };
  const closeAddHandleClick = () => {
    setShowAddForm(false);
  };
  const closeEditHandleClick = () => {
    setShowEditForm(false);
  };
  const closeDeleteHandleClick = () => {
    setShowDeleteForm(false);
  };
  const closeApproveHandleClick = () => {
    setShowApproveForm(false);
  };
  const closeEmployeeForm = () => {
    setShowEmployeeForm(false);
  };
  //extract
  const fetchDataPayrollPeriodById = async (id) => {
    const apiUrl = domain + `/api/PayrollPeriod/${id}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      return response.data; // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
      return null;
    }
  }

  function formatDate(dateString) {
    if (!dateString) {
      return '';
    }
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  function formatTime(time) {
    if (!time) {
      return '';
    }

    const timePart = time.split('T')[1];
    if (timePart) {
      const [hour, minute] = timePart.split(':');
      const hours = parseInt(hour, 10);
      const ampm = hours >= 12 ? 'PM' : 'AM';
      const formattedHours = hours % 12 || 12;

      return `${formattedHours}:${minute} ${ampm}`;
    }
  }

  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet();

    const header = [
      'Id',
      'EmployeeId',
      'Name',
      'Date',
      'TimeIn',
      'DeviceIn',
      'TimeOut',
      'DeviceOut',
      'ShiftName',
      'ReasonForTampering'
    ];
    const headerRow = worksheet.addRow(header);
    worksheet.columns = [
      { key: 'id', width: 30 },
      { key: 'employeePersonalInformationEmployeeId', width: 30 },
      { key: 'employeePersonalInformationFullName', width: 30 },
      { key: 'date', width: 30 },
      { key: 'timeIn', width: 30 },
      { key: 'deviceNameTimeIn', width: 30 },
      { key: 'timeOut', width: 30 },
      { key: 'deviceNameTimeOut', width: 30 },
      { key: 'employeePersonalInformationEmployeeInformationShiftScheduleShiftName', width: 30 },
      { key: 'reasonForTampering', width: 30 },
    ];
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '92d050' },
      };
    });

    const payrollPeriodData = await fetchDataPayrollPeriodById(extractPayrollPeriodId);
    const payrollDateFrom = new Date(payrollPeriodData.dateFrom);
    const payrollDateTo = new Date(payrollPeriodData.dateTo);

    // Set the time to the end of the day for dateTo (23:59:59)
    payrollDateTo.setHours(23, 59, 59, 999);

    // Filter records where the date is within the range
    const filteredData = dateTimeRecordData.filter(record => {
      const recordDate = new Date(record.date);
      return recordDate >= payrollDateFrom && recordDate <= payrollDateTo;
    });

    const sortedData = [...filteredData].sort((a, b) => {
      // Sort by Name first
      if (a.employeePersonalInformationFullName < b.employeePersonalInformationFullName) return -1;
      if (a.employeePersonalInformationFullName > b.employeePersonalInformationFullName) return 1;

      // If Name is the same, sort by Date
      return new Date(a.date) - new Date(b.date);
    });

    sortedData.forEach((item) => {
      worksheet.addRow([
        item.id,
        item.employeePersonalInformationEmployeeId,
        item.employeePersonalInformationFullName,
        formatDate(item.date),
        formatTime(item.timeIn),
        item.deviceNameTimeIn,
        formatTime(item.timeOut),
        item.deviceNameTimeOut,
        item.employeePersonalInformationEmployeeInformationShiftScheduleShiftName,
        item.reasonForTampering,
      ]);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, 'TimeEntries.xlsx');
  };

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);

  useEffect(() => {
    if (approveMessage) {
      const timeoutId = setTimeout(() => {
        setApproveMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [approveMessage]);

  // const [showAddForEmployeeGroup2Logs, setShowAddForEmployeeGroup2Logs] = useState(false);
  // const [employeeGroup2Id, setEmployeeGroup2Id] = useState("");
  // const [employeeGroup2DateFrom, setEmployeeGroup2DateFrom] = useState("");
  // const [employeeGroup2DateTo, setEmployeeGroup2DateTo] = useState("");
  // const openAddForEmployeeGroup2Form = () => {
  //   setShowAddForEmployeeGroup2Logs(true);
  // }
  // const closeAddForEmployeeGroup2Form = () => {
  //   setShowAddForEmployeeGroup2Logs(false);
  // }

  const handleGenerateFixedLogs = async () => {
    // Note: We don't need to manually setShowConfirmGen(false) here 
    // if we want the modal to show the "Processing..." state.
    try {
      const result = await generateLogs(user.id);

      if (result.success) {
        await SetAuditTrail({
          setupArea: "Time Entries",
          actionTaken: "insert",
          field: "Bulk Generate Fixed Logs",
          newValue: "Triggered via Config Table",
          oldValue: "-",
          dateSaved: new Date(),
          savedById: user.id
        });

        setRequestMessage("Fixed logs generated successfully based on employee configurations!");
        setIsSuccess(true);
        setShowRequestMessage(true);
        setShowConfirmGen(false); // Close on success
        await fetchData();
      }
    } catch (error) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage(error.message || "An error occurred during generation");
      setShowConfirmGen(false); // Close on error
    }
  };

  const [showExtractForm, setShowExtractForm] = useState(false);
  const [extractPayrollPeriodId, setExtractPayrollPeriodId] = useState("");
  const openExtractForm = () => {
    setShowExtractForm(true);
  }
  const closeExtractForm = () => {
    setShowExtractForm(false);
  }

  const customUIType = [
    { key: "DEPARTMENT", uiType: FEATURES.DEPARTMENT_FILTER_UI_TYPE }
  ]

  const [shouldGenerate, setShouldGenerate] = useState(false);

  const finalSubmit = () => {
    setShouldGenerate(true);
    applyFilters();
  };

  useEffect(() => {
    if (!shouldGenerate) return;

    generateUploadedTimeEntries();
    setShouldGenerate(false);

    setApiFilterPayload(apiFilterPayload)
    setAdditionalApiFilterPayload(additionalApiFilterPayload)
  }, [
    apiFilterPayload,
    additionalApiFilterPayload,
    shouldGenerate,
    generateUploadedTimeEntries,
    setApiFilterPayload,
    setAdditionalApiFilterPayload,
  ]);

  return (
    <>
      <div className="rounded-lg bg-white p-4 shadow-sm" style={{ border: '1px solid #d1d5db' }}>

        {FEATURES.IS_DYNAMIC_FILTER ?
          <>
            <div className="mb-5">
              <div className="bg-white rounded-lg border border-gray-200 mt-2 p-4">
                <span className="text-sm font-bold text-gray-500 uppercase tracking-widest mb-4 block">Filter</span>
                <DynamicFilterBar
                  requestedFilters={FEATURES.TIME_KEEPING_FILTER}
                  activeFilterState={activeFilterState}
                  onFilterChange={onFilterChange}
                  onApply={applyFilters}
                  onClear={resetFilters}
                  allowAll={false}
                  showButtons={false}
                  customUIType={customUIType}
                />
              </div>
            </div>
            <Button
              name={"GENERATE"}
              icon={<RestartAltIcon />}
              onClick={finalSubmit}
              className={"bg-blue-800 hover:bg-blue-900 text-white border-none cursor-pointer"}
            />
          </>
          :
          <>
            <div className=''>
              <div className="py-1">
                <h4 className="font-medium text-gray-500 mt-0 mb-2">Filter</h4>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 pb-3 pt-3">
                <PayrollPeriodSelect
                  label="Payroll Period"
                  value={payrollPeriodUploadedTimeEntries}
                  setValue={setPayrollPeriodUploadedTimeEntries}
                  isEditable={true}
                  allowSelectAll={false}
                />

                <ClassificationSelectWithAll
                  user={user}
                  label="Classification Type"
                  value={filterClassificationId}
                  setValue={setFilterClassificationId}
                  setActiveRowIds={setActiveRowIds}
                  setSelectedDTR={setSelectedDTR}
                  isEditable={true}
                  allowAll={true}
                />

                {FEATURES.TIMEKEEPING_EMPLOYEETYPE && (
                  <DepartmentIdSelectWithAll
                    label="Department"
                    value={departmentFilter}
                    setValue={setDepartmentFilter}
                    isEditable={true}
                    allowAll={true} />
                )}

                {FEATURES.TIMEKEEPING_EMPLOYEETYPE && (
                  <EmployeeTypeIdSelectWithAll
                    label="Employee Type"
                    value={employeeTypeFilter}
                    setValue={setEmployeeTypeFilter}
                    isEditable={true}
                    allowAll={true} />
                )}

                {FEATURES.TIMEKEEPING_EMPLOYEETYPE && (
                  <VesselIdSelectWithAll
                    label="Vessel"
                    value={vesselFilter}
                    setValue={setVesselFilter}
                    isEditable={true}
                    allowAll={true}
                  />
                )}

              </div>
            </div>
            <Button
              name={"GENERATE"}
              icon={<RestartAltIcon />}
              onClick={generateUploadedTimeEntries}
              className={"bg-blue-800 hover:bg-blue-900 text-white border-none cursor-pointer"}
            />
          </>
        }
      </div>

      <div className="timeBtns row">
        <div className="timeBtn add row">
          {CreateButton("", "icon row", addHandleClick, "ADD", AddIcon)}
        </div>
        {FEATURES.TIMEENTRIES_FIXEDLOGS_CONFIG && (
          <div className="timeBtn add row">
            {/* Now opens confirmation instead of EmployeeType form */}
            {CreateButton("", "icon row", () => setShowConfirmGen(true), "FIXED LOGS", AddIcon)}
          </div>
        )}
        {FEATURES.TIMEENTRIES_FIXEDLOGS_CONFIG && (
          <div className="timeBtn add row">
            {/* Now opens confirmation instead of EmployeeType form */}
            {CreateButton("", "icon row", () => setShowGenerateEmployeeFixedLogs(true), "EMPLOYEE FIXED LOGS", AddIcon)}
          </div>
        )}
        <div className="timeBtn extract row">
          {CreateButton("", "icon row", openExtractForm, "EXTRACT", FileCopyIcon)}
        </div>
        <div className="timeBtn extract row">
          {CreateButton("", "icon row", openUploadTamperedFormHandleClick, "UPLOAD TAMPERED ENTRIES", FileCopyIcon)}
        </div>
      </div>
      <div className="mainte-body-top row hidden">
        {Filter(setFilterDataIndex)}
      </div>
      <div className="mainte-body-top row timeEntries-search-div" style={{ justifyContent: "space-between" }}>
        <>
          {CreateSearchBarWithPlaceHolder("",
            "mainte-search row",
            "mainte-search-icon",
            "mainte-search-input",
            (e) => handleFilter(e.target.value),
            "Search by name or employee id",
            SearchIcon)}
        </>
        <div className="timeBtns row" style={{ padding: "0", display: "none" }}>
          {!showTampered ?
            <div className="timeBtn extract row">
              {CreateButton("", "icon row", handleClickShowTampered, "SHOW TAMPERED ONLY", VisibilityOffIcon)}
            </div>
            :
            <div className="timeBtn extract row">
              {CreateButton("", "icon row", handleClickShowTampered, "SHOW ALL ENTRIES", RemoveRedEyeIcon)}
            </div>
          }
          <div className="timeBtn approve row">
            {CreateButton("", "icon row", () => setShowApproveForm(true), "APPROVE", DoneIcon)}
          </div>
          <div className="timeBtn approve row">
            {CreateButton("", "icon row", () => setIsSelectAll(true), "SELECT ALL", ChecklistIcon)}
          </div>
        </div>
      </div>
      <div className="timeTable container">
        <CreateTable
          dataList={dateTimeRecordData}
          dataHeader={uploadTimeEntriesHeader}
          dataAccessor={uploadTimeEntriesaccessor}
          editHandleClick={editHandleClick}
          deleteHandleClick={deleteHandleClick}
          setSelected={setSelectedDTR}
          isSelectAll={isSelectAll}
          setIsSelectAll={setIsSelectAll}
          activeRowIds={activeRowIds}
          setActiveRowIds={setActiveRowIds}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
        {dateTimeRecordData.length > 0 ? (
          <div></div>
        )
          :
          (
            <div>
              {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                  <img src={loadingSpinner} alt="Loading..." />
                </div>
              ) : (
                <div> {/*<p>No records to display</p>*/}</div>
              )
              }
            </div>
          )}
      </div>
      <AddForm isOpen={showAddForm}
        onClose={closeAddHandleClick}
        employeePersonalInformationId={employeePersonalInformationId}
        setEmployeePersonalInformationId={setEmployeePersonalInformationId}
        employeePersonalInformationFullName={employeePersonalInformationFullName}
        setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
        timeIn={timeIn}
        setTimeIn={setTimeIn}
        deviceNameTimeIn={deviceNameTimeIn}
        setDeviceNameTimeIn={setDeviceNameTimeIn}
        timeOut={timeOut}
        setTimeOut={setTimeOut}
        deviceNameTimeOut={deviceNameTimeOut}
        setDeviceNameTimeOut={setDeviceNameTimeOut}
        setShowEmployeeForm={setShowEmployeeForm}
        handleSubmit={handleSubmit}
      >
      </AddForm>
      <EditForm isOpen={showEditForm}
        onClose={closeEditHandleClick}
        employeePersonalInformationId={employeePersonalInformationId}
        setEmployeePersonalInformationId={setEmployeePersonalInformationId}
        employeePersonalInformationFullName={employeePersonalInformationFullName}
        setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
        timeIn={timeIn}
        setTimeIn={setTimeIn}
        deviceNameTimeIn={deviceNameTimeIn}
        setDeviceNameTimeIn={setDeviceNameTimeIn}
        timeOut={timeOut}
        setTimeOut={setTimeOut}
        deviceNameTimeOut={deviceNameTimeOut}
        setDeviceNameTimeOut={setDeviceNameTimeOut}
        reasonForTampering={reasonForTampering}
        setReasonForTampering={setReasonForTampering}
        handleUpdate={handleUpdate}
      >
      </EditForm>
      <DeleteForm isOpen={showDeleteForm}
        onClose={closeDeleteHandleClick}
        handleDelete={handleDelete}
      >
      </DeleteForm>
      <ApproveForm isOpen={showApproveForm}
        onClose={closeApproveHandleClick}
        handleApprove={approveHandleClick}
      >
      </ApproveForm>
      <EmployeeSelectForm isOpen={showEmployeeForm}
        onClose={closeEmployeeForm}
        setEmployeeId={setEmployeePersonalInformationId}
        setEmployee={setEmployeePersonalInformationFullName}
        userAccessData={userAccess}
      >
      </EmployeeSelectForm>

      {/* <AddEmployeeTypeLogsForm
        isOpen={showEmployeeTypeModal}
        onClose={() => setShowEmployeeTypeModal(false)}
        employeeTypeId={selectedEmployeeTypeId}
        setEmployeeTypeId={setSelectedEmployeeTypeId}
        dateFrom={genDateFrom}
        setDateFrom={setGenDateFrom}
        dateTo={genDateTo}
        setDateTo={setGenDateTo}
        handleSubmit={handleGenerateEmployeeTypeLogs}
      /> */}
      {/* ADDED: Reusable-style confirmation modal */}

      <GenerateEmployeeFixedLogs
        isOpen={showGenerateEmployeeFixedLogs}
        onClose={() => setShowGenerateEmployeeFixedLogs(false)}
        user={user}
        showGeneralMessage={showGeneralMessage}
      />
      <ConfirmationModal
        visible={showConfirmGen}
        onClose={() => setShowConfirmGen(false)}
        onConfirm={handleGenerateFixedLogs}
        title="Generate Fixed Logs"
        message="Are you sure you want to proceed with generating fixed logs for all active configurations?"
        noteMessage="* This will update or overwrite any existing logs for the configured date ranges."
        confirmText="Proceed"
        cancelText="Cancel"
        type="warning"
        isLoading={isGenerating} // Uses the loading state from useGenerateFixedLogs hook
      />
      <ExtractForm isOpen={showExtractForm}
        onClose={closeExtractForm}
        payrollPeriodId={extractPayrollPeriodId}
        setPayrollPeriodId={setExtractPayrollPeriodId}
        handleSubmit={exportToExcel}
      >
      </ExtractForm>
      <GenerateMessage form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      >
      </GenerateMessage>
      <GenerateMessage form={approveMessage}
        message={requestMessage}
        isSuccess={isSuccess}
      >
      </GenerateMessage>

      <GeneralMessage form={showMessage} message={employeeLogMessage} isSuccess={employeeLogIsSuccess} />

      {/* {loadingRequest ? (
        <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: "3005" }}>
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )
      } */}

      <LoadingSpinner loading={loadingRequest || loading || isGenerating} />
    </>
  )
}

function Filter(setFilterDataIndex) {
  const [selectedOption, setSelectedOption] = useState('');

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "EmployeeId":
        setFilterDataIndex(1);
        break;
      case "EmployeeName":
        setFilterDataIndex(2);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <div className="filters row" style={{ alignItems: "center" }}>
      <span style={{ marginRight: "10px" }}>Filter</span>
      <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
        <option value="All">All</option>
        <option value="EmployeeId">Employee Id</option>
        <option value="EmployeeName">Employee Name</option>
      </select>
    </div>
  );
};